import React from "react";

export default function AdminAppointments() {
  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold mb-4">Manage Appointments</h2>
      <p>Admin can manage all appointments here.</p>
    </div>
  );
}